import React from "react";
import styled from "styled-components";
import { colors } from "../../utils/theme";
import { Button } from "antd";

const AddToCartBtn = ({ inCart, children, ...rest }) => {
  return (
    <StyledButton
      type={"primary"}
      block
      size={"large"}
      in_cart={inCart ? 1 : 0}
      {...rest}
    >
      {children}
    </StyledButton>
  );
};

const StyledButton = styled(Button)`
  color: ${({ in_cart }) =>
    in_cart ? colors.added_to_cart_btn : colors.cta_btn_text} !important;
  border-color: ${({ in_cart }) =>
    in_cart ? colors.added_to_cart_btn : colors.cta_btn} !important;
  background: ${({ in_cart }) =>
    in_cart ? "#fff" : colors.cta_btn} !important;
  display: flex;
  align-items: center;
  justify-content: center;

  &:hover {
    border-color: ${({ in_cart }) =>
      in_cart ? colors.added_to_cart_btn : colors.primary70} !important;
    background: ${({ in_cart }) =>
      in_cart ? "#fff" : colors.primary70} !important;
    color: ${colors.cta_btn_text};
  }
`;

export default AddToCartBtn;
